module.exports = __webpack_public_path__ + "static/media/status_green.0e2d44bb.svg";